export default __webpack_public_path__ + "static/media/sg_jg_not_found.2a430d11.svg";